// extracted by mini-css-extract-plugin
export var fadeInAnimation = "ShortCustomers-module--fadeInAnimation--71601";
export var icon = "ShortCustomers-module--icon--952f0";
export var iconWrapper = "ShortCustomers-module--iconWrapper--2d40d";
export var layout = "ShortCustomers-module--layout--6b18d";
export var smallerPadding = "ShortCustomers-module--smallerPadding--3ee1c";
export var wrapper = "ShortCustomers-module--wrapper--daba9";